<template>
  <fieldset>
    <legend>
      <span class="pull-left">{{ $t('form.sickness.legend') }}</span>
      <!-- <a class="fa fa-question-circle" @click="displayModal($event, 0)" /> -->
      <a
        class="pull-right"
        ref="collapseLink"
        data-toggle="collapse"
        href="#collapse_sickness"
        role="button"
        aria-expanded="true"
        aria-controls="collapse_sickness"
      >
        <span class="fa fa-angle-up"></span>
        <span class="fa fa-angle-down"></span>
      </a>
    </legend>

    <modal v-show="modals[0]" @close="$set(modals, 0, false)">
      <h2 slot="modal-header">{{ $t('form.sickness.legend') }}</h2>
      <div slot="modal-body"></div>
    </modal>

    <div class="collapse show" id="collapse_sickness" ref="collapseElement">
      <div class="form-group">
        <div>
          <label for="sickness_name">
            {{ $t('form.sickness.label') }}
          </label>
          <label for="sickness_name">
            {{ $t('form.sickness.contact.name.label') }}
          </label>
          <input
            type="text"
            class="form-control"
            id="sickness_name"
            :placeholder="$t('form.sickness.contact.name.placeholder')"
            v-model="sickness.name"
            @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
            required
          />
        </div>
        <div>
          <label for="sickness_phone">
            {{ $t('form.sickness.contact.phone.label') }}
          </label>
          <input
            type="text"
            class="form-control"
            id="sickness_phone"
            :placeholder="$t('form.sickness.contact.phone.placeholder')"
            v-model="sickness.phone"
            @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
            required
          />
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  data() {
    return {
      sickness: {
        name: "",
        phone: ""
      }
    };
  },
  watch: {
    sickness: {
      handler() {
        this.$store.commit("updateSickness", this.sickness);
      },
      deep: true
    }
  }
};
</script>